export default __webpack_public_path__ + "static/Gellix-Bold-2d821e501ce5872db8c1039662fe7339.woff2";